import axios from "axios";
import {
  type ActivationReq,
  type CloseOff,
  type Collection,
  type HistoricalSearchRequest,
  type NewUser,
  type ParcelRange,
  type Reason,
  type ReceiveParcel,
  type UnexpectedParcel,
  type UserActivityDetailsPayload,
  type UserActivityRequest,
} from "@/models";
import { createElementBlock } from "vue";

const gateWayURL = import.meta.env.RAM_APP_GATEWAY_URL;

export const DashboardAPI = axios.create({
  baseURL: `${gateWayURL}/api/v1/Dashboard`,
  headers: {
    "Access-Control-Allow-Origin": "true",
  },
});

export const ClosureReasonAPI = axios.create({
  baseURL: `${gateWayURL}/api/v1/ClosureReason`,
  headers: {
    "Access-Control-Allow-Origin": "true",
  },
});

export const ParcelAPI = axios.create({
  baseURL: `${gateWayURL}/api/v1/Parcel`,
  headers: {
    "Access-Control-Allow-Origin": "true",
  },
});

export const ConfirmCollectionAPI = axios.create({
  baseURL: `${gateWayURL}/api/v1/ConfirmCollection`,
  headers: {
    "Access-Control-Allow-Origin": "true",
  },
});

export const ReceivingAPI = axios.create({
  baseURL: `${gateWayURL}/api/v1/Receiving`,
  headers: {
    "Access-Control-Allow-Origin": "true",
  },
});

export const ReportsAPI = axios.create({
  baseURL: `${gateWayURL}/api/v1/Report`,
  headers: {
    "Access-Control-Allow-Origin": "true",
  },
});

export const UserAPI = axios.create({
  baseURL: `${gateWayURL}/api/v1/User`,
  headers: {
    "Access-Control-Allow-Origin": "true",
  },
});

export const CollectionAPI = axios.create({
  baseURL: `${gateWayURL}/api/v1/ConfirmCollection`,
  headers: {
    "Access-Control-Allow-Origin": "true",
  },
});

export default {
  // Auth API
  login(emailID: string, password: string , captchaToken: string) {
    return UserAPI.post("/Login", { emailID, password, captchaToken });
  },

  logout(userID: number) {
    return UserAPI.post("/Logoff", { userID: userID });
  },

  activateUser(data: ActivationReq) {
    return UserAPI.post("/ActivateUser", data);
  },

  saveTokenForgotPassord(emailID: string) {
    return UserAPI.post("/SaveTokenForgotPassword", { emailID: emailID });
  },

  getUsersLookup() {
    return UserAPI.get("/GetUsersLookup");
  },

  //Dashboard API
  getDashboardDetails() {
    return DashboardAPI.get("/GetDashboardDetails");
  },

  //Closure Reason Manage API
  getClosureReasons() {
    return ClosureReasonAPI.get("/GetClosureReasonDetails");
  },

  saveClosureReason(data: Reason) {
    return ClosureReasonAPI.post("/SaveClosureReason", data);
  },

  getClosureReasonById(recordID: any) {
    return ClosureReasonAPI.get(`/GetClosureReasonById?recordID=${recordID}`);
  },

  updateClosureReason(data: Reason) {
    return ClosureReasonAPI.put("/UpdateClosureReason", data);
  },

  //closeoff consignment API
  saveConfirmCloseOff(data: CloseOff) {
    return ClosureReasonAPI.post("/SaveConsignmentCloseOff", data);
  },

  getClosureReasonList() {
    return ClosureReasonAPI.get("/GetClosureReasonList");
  },

  //Parcel Format range Manage API

  getParcelRangeDetails() {
    return ParcelAPI.get("/GetParcelRangeDetails");
  },

  saveParcelRange(data: ParcelRange) {
    return ParcelAPI.post("/SaveParcelRange", data);
  },

  getParcelRangeById(recordID: number) {
    return ParcelAPI.get(`/GetParcelRangeById?recordId=${recordID}`);
  },

  updateParcelRange(data: ParcelRange) {
    return ParcelAPI.put("/UpdateParcelRange", data);
  },

  //User Management API's
  saveUser(data: NewUser) {
    return UserAPI.post("/AddUser", data);
  },
  updateUser(data: NewUser) {
    return UserAPI.put("/EditUser", data);
  },

  getUserDetails() {
    return UserAPI.get("/GetUserDetails");
  },

  getUserById(recordID: number) {
    return UserAPI.get(`/GetUserById?recordId=${recordID}`);
  },

  getViewExpectedParcels(consignmentID: string) {
    return ReportsAPI.post("/GetViewExpectedParcels", {
      consignmentID: consignmentID,
    });
  },

  getViewInHubParcels() {
    return ReportsAPI.get("/GetViewInhubParcels");
  },

  getViewCollected() {
    return ReportsAPI.get("/GetViewCollected");
  },

  getViewUserActivity(data: UserActivityRequest) {
    return ReportsAPI.post("/GetViewUserActivity", data);
  },

  getViewHistoricalSearch(data: HistoricalSearchRequest) {
    return ReportsAPI.post("/GetViewHistoricalSearch", data);
  },

  getUserActivityDetails(data: UserActivityDetailsPayload){
    return ReportsAPI.post("/GetUserActivityDetails",data);
  },

  //Receiving API's

  scanReceivedParcel(data: ReceiveParcel) {
    return ReceivingAPI.post("/ScanReceivedParcel", data);
  },

  saveUnexpectedReceivedParcel(data: UnexpectedParcel) {
    return ReceivingAPI.post("/SaveUnexpectedReceivedParcel", data);
  },

  getRecentReceivingDetails(createdBy: number) {
    return ReceivingAPI.get(`GetRecentReceivingDetails?createdBy=${createdBy}`);
  },

  getParcelsInHubDetails(payload: {
    consignmentID: string;
    receiverName: string;
    receiverContactNumber: string;
    recordDT: string | null;
  }) {
    return CollectionAPI.post("/GetParcelsInhubDetails", payload);
  },

  saveConfirmCollection(payload: Collection) {
    return CollectionAPI.post("/SaveConfirmCollection", payload);
  },

  getParcelImageUrl(data:any){
    return ReportsAPI.post('/GetCollectorImages',data)
  }
};
